import API from "../../../../../../../utils/apiCalling";
import { config } from "../../../../../../../utils/apiUrl";

const api = new API();


/*
|--------------------------------------------------------------------------
| BUILD QUERY
|--------------------------------------------------------------------------
*/

const buildQueryString = (
    params = {}
) => {
    const query =
        new URLSearchParams();

    Object.entries(
        params
    ).forEach(
        ([
            key,
            value,
        ]) => {
            if (
                value === undefined ||
                value === null ||
                value === ""
            ) {
                return;
            }

            if (
                [
                    "status",
                    "paymentStatus",
                    "taxType",
                    "paymentMethod",
                ].includes(
                    key
                ) &&
                String(
                    value
                ).toUpperCase() ===
                "ALL"
            ) {
                return;
            }

            query.append(
                key,
                value
            );
        }
    );

    const value =
        query.toString();

    return value
        ? `?${value}`
        : "";
};


/*
|--------------------------------------------------------------------------
| RESPONSE DATA
|--------------------------------------------------------------------------
*/

const getResponseData = (
    response
) => {
    /*
    |--------------------------------------------------------------------------
    | Axios
    |--------------------------------------------------------------------------
    */

    if (
        response?.data?.data
    ) {
        return response
            .data
            .data;
    }

    /*
    |--------------------------------------------------------------------------
    | Custom API returns body
    |--------------------------------------------------------------------------
    */

    if (
        response?.data
    ) {
        return response.data;
    }

    return response || {};
};


/*
|--------------------------------------------------------------------------
| GET URL BY REPORT
|--------------------------------------------------------------------------
*/

const getReportUrl = (
    reportType
) => {
    switch (
        reportType
    ) {
        case "PURCHASE_REGISTER":
            return config
                .getPurchaseRegister();

        case "SUPPLIER_SUMMARY":
            return config
                .getSupplierPurchaseSummary();

        case "DEBIT_NOTES":
            return config
                .getPurchaseDebitNoteReport();

        case "PAYMENT_OUT":
            return config
                .getPurchasePaymentOutReport();

        case "OUTSTANDING":
            return config
                .getPurchaseOutstandingReport();

        case "AGEING":
            return config
                .getPurchaseAgeingReport();

        case "GST_INPUT":
            return config
                .getPurchaseGstInputReport();

        default:
            throw new Error(
                "Invalid purchase report type."
            );
    }
};


/*
|--------------------------------------------------------------------------
| FETCH ALL REPORT RECORDS
|--------------------------------------------------------------------------
*/

export const fetchAllPurchaseReportRecords =
    async ({
        reportType,

        filters = {},
    }) => {
        const baseUrl =
            getReportUrl(
                reportType
            );

        const allRecords =
            [];

        let page =
            1;

        let totalPages =
            1;

        /*
        |--------------------------------------------------------------------------
        | Backend currently supports maximum 200.
        |--------------------------------------------------------------------------
        */

        const limit =
            200;


        do {
            const queryString =
                buildQueryString({
                    ...filters,

                    page,

                    limit,
                });

            const response =
                await api.get(
                    `${baseUrl}${queryString}`
                );

            const data =
                getResponseData(
                    response
                ) || {};

            const records =
                Array.isArray(
                    data?.records
                )
                    ? data.records
                    : [];

            allRecords.push(
                ...records
            );

            totalPages =
                Math.max(
                    Number(
                        data
                            ?.pagination
                            ?.totalPages ||
                        1
                    ),
                    1
                );

            page +=
                1;

        } while (
            page <=
            totalPages
        );


        return allRecords;
    };


export default fetchAllPurchaseReportRecords;